import { render, staticRenderFns } from "./AdminCalendarLayout.vue?vue&type=template&id=7a23e5d7&scoped=true&"
import script from "./AdminCalendarLayout.vue?vue&type=script&setup=true&lang=js&"
export * from "./AdminCalendarLayout.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a23e5d7",
  null
  
)

export default component.exports